import { Button } from '@material-ui/core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { QuoteStatuses, DialogNames, AnalyticsEventKeys } from '../constants';
import { Dispatch } from '../redux/store';
import currentDate from '../currentDate';

const RequestChangesOnQuote = function RequestChangesOnQuote(): React.ReactElement {
  const dispatch = useDispatch<Dispatch>();
  const onClick = function handleOnClick(): void {
    dispatch.quote.setQuoteStatus(
      QuoteStatuses.ChangesRequested,
      currentDate()
    );
    dispatch.dialog.setOpenDialog(DialogNames.SendFeedback);
    dispatch.analytics.sendEvent({
      eventType: AnalyticsEventKeys.RequestChangesClicked
    });
  };

  return (
    <Button variant='outlined' color='inherit' onClick={onClick}>
      <FormattedMessage id='requestChanges' defaultMessage='Request Changes' />
    </Button>
  );
};

export default RequestChangesOnQuote;
